var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","download":"","href":_vm.link,"target":"_blank"}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("fa-solid fa-file-archive")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }